<forge-icon-button *ngIf="authenticated" #popup="forgePopover" [forgePopover]="popupTemplate" (click)="popup.open()"
                   [forgePopoverCloseOnBlur]="true" forgePopoverArrow="true" forgePopoverPlacement="bottom-end"
                   tabindex="0" aria-label="Application launcher">
    <forge-tooltip placement="bottom">Apps</forge-tooltip>
    <forge-icon style="--forge-icon-color: var(--_app-bar-foreground);" name="apps"></forge-icon>
</forge-icon-button>

<ng-template #popupTemplate>
    <div class="nine-box">
        <div *ngIf="isLoaded; else busy" fxLayout="column" fxLayoutAlign="space-between" [ngClass]="nineBoxClasses">

            <ng-container *ngFor="let row of mainApps">
                <div fxLayout="row" fxLayoutAlign="start start" class="appLinkRow">
                    <ng-container *ngFor="let app of row; let i = index">
                        <application-link fxFlex="25%" [application]="app" [autoFocus]="i === 0">
                        </application-link>
                    </ng-container>
                </div>
            </ng-container>

            <div *ngIf="showAll">
                <ng-container *ngFor="let row of moreApps">
                    <div fxLayout="row" fxLayoutAlign="start start" class="appLinkRow">
                        <ng-container *ngFor="let app of row">
                            <application-link fxFlex="25%" [application]="app">
                            </application-link>
                        </ng-container>
                    </div>
                </ng-container>
            </div>

            <div *ngIf="showMoreOption" (click)="onShowMoreClick($event)" class="appShowOption"
                 telemetry="Submission-More">
                <span>More</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #busy>
    <div fxLayout="row" fxLayoutAlign="space-around center" class="skeletons">
        <div fxLayout="column" fxLayoutAlign="space-between center">
            <forge-skeleton avatar></forge-skeleton>
            <forge-skeleton text></forge-skeleton>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center">
            <forge-skeleton avatar></forge-skeleton>
            <forge-skeleton text></forge-skeleton>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center">
            <forge-skeleton avatar></forge-skeleton>
            <forge-skeleton text></forge-skeleton>
        </div>
        <div fxLayout="column" fxLayoutAlign="space-between center">
            <forge-skeleton avatar></forge-skeleton>
            <forge-skeleton text></forge-skeleton>
        </div>
    </div>
</ng-template>